import React from 'react';
import {useHistory} from 'react-router'
import moment from 'moment';
import {makeStyles, withStyles, Typography, TextField, Grid, Button, Paper, Divider} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import WarningBox from './WarningBox';
import customAxios from "../../../API/customAxios";
import {FormattedMessage, useIntl} from 'react-intl';
import {reviewStyle} from '../../../UIComponent/CommonStyle'
import {rangeToDayConverter} from '../../../Function/globalFunction';
import * as ErrorMessage from './DateValidErrorMessage';
import { SICK_LEAVE } from '../../../shared/Constant/LeaveTypes';

const useStyles = makeStyles((theme) => ({
    ...reviewStyle(theme),
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 450
    },
    disabledInput: {
        "& .MuiInputBase-root.Mui-disabled": {
            color: "black"
        }
    }
}));

export default function Review(
    {
        handleClose,
        open,
        mode,
        applicationId,
        employeeId,
        employeeName,
        typeId,
        typeName,
        startDate,
        startTime,
        untilDate,
        endTime,
        period,
        reason,
        attachment,
        editAttachment,
        staffDuty,
        isCompLeave,
        takenCompLeave,
    }) {

    const intl = useIntl();
    const history = useHistory();
    const [showAfterSubmittion, setShowAfterSubmittion] = React.useState(false);
    const [isError, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [am, setAM] = React.useState();
    const [pm, setPM] = React.useState();
    const [attachmentText, setAttachmentText] = React.useState();
    const [appliedForm, setAppliedForm] = React.useState();
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [submitDisabled, setSubmitDisabled] = React.useState(true);
    const [submitButtonText, setSubmitButtonText] = React.useState(intl.formatMessage({id: 'new_application.review_confirm'}));
    const attachmentArray = 'attachment[]';
    const isNewCompLeave = isCompLeave && (staffDuty != window.global.shiftDuty);

    React.useEffect(() => {
        switch (mode) {
            case window.global.submitMode:
            case window.global.formMode:
                if (!attachment.length) {
                    setAttachmentText(<FormattedMessage
                        id="new_application.none"
                    />)
                } else {
                    setAttachmentText(<FormattedMessage
                        id="new_application.supporting_documentation_provided"
                    />)
                }
                break;
            case window.global.editMode:
                if (!attachment.length) {
                    setAttachmentText(<FormattedMessage
                        id="new_application.none"
                    />)
                } else {
                    setAttachmentText(<FormattedMessage
                        id="new_application.supporting_documentation_provided"
                    />)
                }
                break;
        }
    }, [attachment]);

    React.useEffect(() => {
        if (staffDuty === window.global.officeHours) {
            setAM(window.global.am);
            setPM(window.global.pm);
        } else {
            setAM(window.global.sectionOne);
            setPM(window.global.sectionTwo);
        }
    }, [staffDuty]);

    React.useEffect(() => {
        if (employeeId) {
            switch (mode) {
                case window.global.submitMode:
                case window.global.formMode:
                    customAxios.get(`/get_applied_application/submit_form/employee/` + employeeId)
                        .then(res => {
                            var getAppliedApplication = res.data[0];
                            setAppliedForm(getAppliedApplication);
                            setSubmitDisabled(false);
                        })
                    break;
                case window.global.editMode:
                    customAxios.get(`/get_applied_application/` + applicationId + `/employee/` + employeeId)
                        .then(res => {
                            var getAppliedApplication = res.data[1];
                            setAppliedForm(getAppliedApplication);
                            setSubmitDisabled(false);
                        })
                    break;
            }
        }
    }, [employeeId])

    const classes = useStyles();
    const StyledDivider = withStyles((theme) => ({
        root: {
            background: '#DCDCDC',
            marginBottom: theme.spacing(1),
            height: 2,
        },
    }))(Divider);

    const handleCancel = (event, reason) => {
        if (reason !== 'backdropClick') {
            handleClose();
        }
    };

    const handleConfirmOpen = () => {
        setConfirmOpen(true);
    };
    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const appliedDayChecking = () => {
        var duplicate = [];
        for (var i = 0; i < appliedForm.length; i++) {
            var selectStartDate = moment(startDate, window.global.displayFormat).format(window.global.momentFormat);
            var selectEndDate = moment(untilDate, window.global.displayFormat).format(window.global.momentFormat);
            var selectDayRange = rangeToDayConverter(selectStartDate, selectEndDate);
            var appliedDayRange = rangeToDayConverter(appliedForm[i].start_date, appliedForm[i].until_date);

            switch (appliedForm[i].start_date) {
                case appliedForm[i].until_date:
                    for (var k = 0; k < selectDayRange.length; k++) {
                        // Check start date included in applied date
                        if (k === 0) {
                            if (selectDayRange[k] === appliedForm[i].start_date && startTime === appliedForm[i].start_time) {
                                duplicate.push(selectDayRange[k]);
                            } else if (selectDayRange[k] === appliedForm[i].start_date && appliedForm[i].end_time === pm && startTime === pm) {
                                duplicate.push(selectDayRange[k]);
                            } else if (selectDayRange[k] === appliedForm[i].start_date && selectEndDate !== appliedForm[i].until_date && appliedForm[i].end_time === pm && startTime === am) {
                                duplicate.push(selectDayRange[k]);
                            } else if (selectDayRange[k] === appliedForm[i].start_date && appliedForm[i].end_time === pm && endTime === pm) {
                                duplicate.push(selectDayRange[k]);
                            }
                            // Check end date included in applied date
                        } else if (k === selectDayRange.length - 1) {
                            if (selectDayRange[k] === appliedForm[i].until_date && endTime === appliedForm[i].end_time) {
                                duplicate.push(selectDayRange[k]);
                            } else if (selectDayRange[k] === appliedForm[i].until_date && appliedForm[i].start_time === am && startTime === am) {
                                duplicate.push(selectDayRange[k]);
                            } else if (selectDayRange[k] === appliedForm[i].until_date && appliedForm[i].start_time === am && endTime === am) {
                                duplicate.push(selectDayRange[k]);
                            } else if (selectDayRange[k] === appliedForm[i].until_date && selectStartDate !== appliedForm[i].start_date && appliedForm[i].start_time === am && endTime === pm) {
                                duplicate.push(selectDayRange[k]);
                            }
                            // Check end middle included in applied date
                        } else {
                            if (selectDayRange[k] === appliedForm[i].start_date && selectDayRange[k] === appliedForm[i].until_date) {
                                duplicate.push(selectDayRange[k]);
                            }
                        }
                    }
                    break;
                default:
                    for (var j = 0; j < appliedDayRange.length; j++) {
                        for (var k = 0; k < selectDayRange.length; k++) {
                            // Check start date included in applied date
                            if (j === 0) {
                                if (appliedDayRange[j] === selectDayRange[k] && appliedForm[i].start_time === endTime) {
                                    duplicate.push(selectDayRange[k]);
                                } else if (appliedDayRange[j] === selectDayRange[k] && appliedForm[i].start_time === am && endTime === pm) {
                                    duplicate.push(selectDayRange[k]);
                                }
                                // Check end date included in applied date
                            } else if (j === appliedDayRange.length - 1) {
                                if (appliedDayRange[j] === selectDayRange[k] && appliedForm[i].end_time === startTime) {
                                    duplicate.push(selectDayRange[k]);
                                } else if (appliedDayRange[j] === selectDayRange[k] && appliedForm[i].end_time === pm && startTime === am) {
                                    duplicate.push(selectDayRange[k]);
                                }
                                // Check end middle included in applied date
                            } else {
                                if (appliedDayRange[j] === selectDayRange[k]) {
                                    duplicate.push(selectDayRange[k]);
                                }
                            }
                        }
                    }
                    break;
            }
        }
        return duplicate;
    };

    function popUp() {
        return alert(intl.formatMessage({id: 'error.multiple_leave'}));
    }

    const post = () => {
        const submitPath = isNewCompLeave ? '/submit_comp_leave_req' : '/submit_application';
        const formData = new FormData();
        if (attachment) {
            attachment.map((file) => {
                formData.append(attachmentArray, JSON.stringify(file));
            });
        } else {
            attachment = [];
        }
        formData.append("employee_id", employeeId);
        formData.append("type_id", typeId);
        formData.append("duration", 'Range');
        formData.append("start_date", startDate);
        formData.append("start_time", startTime);
        formData.append("until_date", untilDate);
        formData.append("end_time", endTime);
        formData.append("period", period);
        formData.append("reason", reason);
        formData.append("status", window.global.submitted);
        isNewCompLeave ? formData.append("hours", takenCompLeave) : '';

        customAxios.post(submitPath, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            const status = res.status

            if (status === 201) {
                setShowAfterSubmittion(true);
                switch (mode) {
                    case window.global.submitMode:
                        setTimeout(function () {
                            history.push('/leave_application');
                        }, 3000);
                        break;
                    case window.global.formMode:
                        setTimeout(function () {
                            window.location.reload();
                        }, 3000);
                }
            }
        }, error => {
            if (typeof error?.response?.data?.message?.update_result != "undefined") {
                if (error?.response?.data?.message && error?.response?.data?.message?.leave_type === SICK_LEAVE) {
                    alert(ErrorMessage.sickLeave(
                        intl,
                        error?.response?.data?.message,
                        'apply'
                    ));
                } else {
                    alert(ErrorMessage.annualLeave(
                        intl,
                        error?.response?.data?.message?.update_result,
                        error?.response?.data?.message?.exceeded
                    ));
                }
                handleCancel();
            } else {
                returnMessage(error?.response?.data?.message);
                setShowAfterSubmittion(true);
                setError(true);
                setTimeout(function () {
                    setShowAfterSubmittion(false);
                    handleCancel();
                }, 6000);
            }
        });
    };

    const editPost = () => {
        const formData = new FormData();
        switch (editAttachment) {
            case '':
                if (attachment) {
                    attachment.map((file) => {
                        formData.append(attachmentArray, JSON.stringify(file));
                    });
                } else {
                    formData.append("attachment", 'remove');
                }
                break;
            default:
                if (attachment) {
                    attachment.map((file) => {
                        formData.append(attachmentArray, JSON.stringify(file));
                    });
                } else {
                    attachment = '';
                }
                break;
        }
        formData.append("id", applicationId);
        formData.append("employee_id", employeeId);
        formData.append("type_id", typeId);
        formData.append("duration", 'Range');
        formData.append("start_date", startDate);
        formData.append("start_time", startTime);
        formData.append("until_date", untilDate);
        formData.append("end_time", endTime);
        formData.append("period", period);
        formData.append("reason", reason);

        customAxios.post(`/edit_application/` + applicationId, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            const status = res.status
            if (status === 201) {
                setShowAfterSubmittion(true);
                setTimeout(function () {
                    window.location.reload();
                }, 3000);
            }
        }, error => {
            if (typeof error.response.data.message['update_result'] != "undefined") {
                alert(ErrorMessage.annualLeave(
                    intl,
                    error.response.data.message['update_result'],
                    error.response.data.message['exceeded']
                ));
                handleCancel();
            } else {
                returnMessage(error.response.data.message);
                setShowAfterSubmittion(true);
                setError(true);
                setTimeout(function () {
                    setShowAfterSubmittion(false);
                    handleCancel();
                }, 6000);
            }
        });
    }

    const handleSubmit = evt => {
        evt.preventDefault();
        const checking = appliedDayChecking();
        setSubmitDisabled(true);
        setSubmitButtonText(intl.formatMessage({id: 'waiting'}));
        switch (mode) {
            case window.global.submitMode:
            case window.global.formMode:
                if (checking.length) {
                    popUp()
                } else {
                    post();
                }
                break;
            case window.global.editMode:
                if (checking.length) {
                    popUp()
                } else {
                    editPost();
                }
                break;
        }
    };

    const returnMessage = (apiErrorMessage) => {
        if (apiErrorMessage) {
            setErrorMessage(intl.formatMessage({id: "error." + apiErrorMessage}));
        } else {
            setErrorMessage(intl.formatMessage({id: 'error.general_message'}));
        }
    }

    return (
        <React.Fragment>
            <Modal 
                   aria-labelledby="confirmation-modal-title"
                   aria-describedby="confirmation-modal-description"
                   className={classes.modal}
                   open={open}
                   onClose={handleCancel}
                   closeAfterTransition
                   BackdropComponent={Backdrop}
                   BackdropProps={{
                       timeout: 500,
                   }}
            >
                <Fade in={open}>
                    {!showAfterSubmittion ?
                        <Paper className={classes.modalPaper}>
                            <Typography variant="h6" color="primary" className={classes.title}>
                                <FormattedMessage
                                    id="new_application.review_title"
                                />
                            </Typography>
                            <StyledDivider/>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography className={classes.subtitle}>
                                        <FormattedMessage
                                            id="new_application.review_subtitle"
                                        />
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className={classes.subtitle}>
                                        <FormattedMessage
                                            id="new_application.review_name"
                                        />:
                                    </Typography>
                                    <Typography className={classes.subtitle}>
                                        <FormattedMessage
                                            id="new_application.leave_type"
                                        />:
                                    </Typography>
                                    <Typography className={classes.subtitle}>
                                        <FormattedMessage
                                            id="common.from"
                                        />:
                                    </Typography>
                                    <Typography className={classes.subtitle}>
                                        <FormattedMessage
                                            id="common.to"
                                        />:
                                    </Typography>
                                    <Typography className={classes.subtitle}>
                                        {isNewCompLeave ? (
                                            <FormattedMessage
                                                id="comp_leave.hours"
                                            />
                                        ) : (
                                            <FormattedMessage
                                                id="new_application.days"
                                            />
                                        )}:
                                    </Typography>
                                    <Typography className={classes.subtitle}>
                                        <FormattedMessage
                                            id="new_application.supporting_document"
                                        />:
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography className={classes.subtitle}>{employeeName}</Typography>
                                    <Typography className={classes.subtitle}>{typeName}</Typography>
                                    <Typography
                                        className={classes.subtitle}>{startDate} {isNewCompLeave ? startTime : intl.formatMessage({id: 'new_application.' + startTime})}</Typography>
                                    <Typography
                                        className={classes.subtitle}>{untilDate} {isNewCompLeave ? endTime : intl.formatMessage({id: 'new_application.' + endTime})}</Typography>
                                    <Typography className={classes.subtitle}>{isNewCompLeave ? takenCompLeave : period}</Typography>
                                    <Typography className={classes.subtitle}>{attachmentText}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className={classes.subtitle}>
                                        <FormattedMessage
                                            id="new_application.reason"
                                        />
                                        :</Typography>
                                    <TextField
                                        disabled
                                        key="Reason"
                                        variant="outlined"
                                        id="reason_id"
                                        name="reason"
                                        defaultValue={reason}
                                        multiline
                                        rows={2}
                                        fullWidth
                                        className={classes.disabledInput}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <div className={classes.buttonDiv}>
                                        <Button
                                            disabled={submitDisabled}
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                            className={classes.submitButton}
                                        >
                                            {submitButtonText}
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="secondary"
                                            onClick={handleCancel}
                                            className={classes.submitButton}
                                        >
                                            <FormattedMessage
                                                id="new_application.review_cancel"
                                            />
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </Paper>
                        :
                        <Paper className={classes.afterSubmitPage}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {!isError ? <Typography className={classes.title}>
                                            <FormattedMessage
                                                id="new_application.review_success_message"
                                            />
                                        </Typography> :
                                        <Typography className={classes.title}>
                                            {errorMessage}
                                        </Typography>}
                                </Grid>
                                <Grid item xs={12}>
                                    {!isError ? <CheckCircleIcon style={{fontSize: '100px', color: 'green'}}/> :
                                        <CancelIcon color="secondary" style={{fontSize: '100px'}}/>}
                                </Grid>
                            </Grid>
                        </Paper>
                    }
                </Fade>
            </Modal>
            {confirmOpen && (
                <WarningBox handleClose={handleConfirmClose} open={confirmOpen} mode={mode} post={post}
                            editPost={editPost}/>
            )}
        </React.Fragment>
    );
}
